// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navigationlinklist__overview{margin-top:5.666rem;display:inline-block}.navigationlinklist__item:not(:first-child){padding-top:2rem}.navigationlinklist__headline{margin-top:4rem;font-size:1.2rem}.submenuflyout--has-showall-links .navigationlinklist__headline{margin-top:0}.navigationlinklist__overview{margin-top:2rem}", ""]);
// Exports
module.exports = exports;
